import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function OfferSection() {
  const items = [{
    name: '1 Clase Gratis (musculación o funcional, tú eliges)',
    value: 'S/. 35'
  }, {
    name: 'Evaluación inicial de tu condición física',
    value: 'S/. 50'
  }, {
    name: 'Orientación nutricional básica personalizada',
    value: 'S/. 60'
  }, {
    name: 'Atención directa por WhatsApp con tu instructor',
    value: 'Incluido'
  }];
  return <section className="py-24 bg-gym-dark relative overflow-hidden" data-id="element-243">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gym-green/5 rounded-full blur-3xl pointer-events-none" data-id="element-244"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-246">
          <div className="flex justify-center mb-6" data-id="element-247">
            <Gift size={48} className="text-gym-green" data-id="element-248" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 uppercase tracking-wide text-white" data-id="element-249">
            Qué obtienes cuando nos{' '}
            <span className="text-gym-green" data-id="element-250">contactas hoy</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gym-charcoal rounded-2xl border border-gym-charcoalLight overflow-hidden shadow-2xl" data-id="element-251">
          <div className="p-8" data-id="element-252">
            <h3 className="text-2xl font-bold text-white mb-8 uppercase tracking-wider border-b border-gym-charcoalLight pb-4" data-id="element-253">
              Tu Paquete de Bienvenida
            </h3>

            <ul className="space-y-6" data-id="element-254">
              {items.map((item, index) => <li key={index} className="flex items-center justify-between border-b border-gym-charcoalLight/50 pb-4 last:border-0 last:pb-0" data-id="element-255">
                  <div className="flex items-start gap-3" data-id="element-256">
                    <CheckCircle2 size={24} className="text-gym-green shrink-0 mt-0.5" data-id="element-257" />
                    <span className="text-lg text-gray-300 font-medium" data-id="element-258">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-lg font-bold text-gray-400 line-through shrink-0 ml-4" data-id="element-259">
                    {item.value}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-gym-charcoalLight p-8 border-t border-gym-charcoalLight flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-260">
            <div data-id="element-261">
              <p className="text-gray-400 text-lg uppercase tracking-wider font-bold" data-id="element-262">
                Total de Valor: <span className="line-through" data-id="element-263">S/. 145</span>
              </p>
            </div>
            <div className="text-center md:text-right" data-id="element-264">
              <p className="text-gray-400 text-sm uppercase tracking-wider font-bold mb-1" data-id="element-265">
                Lo que pagas hoy:
              </p>
              <p className="text-5xl font-bold text-gym-green" data-id="element-266">S/. 0</p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-267">
          <p className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide mb-4" data-id="element-268">
            Sí. Todo eso es <span className="text-gym-green" data-id="element-269">GRATIS</span> en tu
            primera visita.
          </p>
          <p className="text-xl text-gray-400 italic" data-id="element-270">
            Porque estamos seguros de que cuando lo experimentes, vas a querer
            quedarte.
          </p>
        </motion.div>
      </div>
    </section>;
}